// ===============================
// Similar Products Popup (Buddy😎 Performance Edition)
// - Zero LCP impact (runs after render)
// - Minimal INP cost (light DOM cloning)
// - Zero TBT (async + non-blocking)
// - PageSpeed friendly (GPU-safe transitions)
// ===============================

// innerHTML alone doesn't execute <script> tags — this re-creates them
function kymeeSetInnerHTMLWithScripts(element, html) {
  element.innerHTML = html;
  element.querySelectorAll('script').forEach((oldScriptTag) => {
    const newScriptTag = document.createElement('script');
    Array.from(oldScriptTag.attributes).forEach((attribute) => {
      newScriptTag.setAttribute(attribute.name, attribute.value);
    });
    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("similar-products-popup");
  const container = document.getElementById("similar-products-container");

  // 🧠 Helper: Show popup (non-blocking)
  const openPopup = (productId) => {
    const template = document.getElementById(`similar-products-template-${productId}`);
    if (!template || !container || !popup) return;

    // Clone instead of re-parsing innerHTML (fast)
    const fragment = template.content ? template.content.cloneNode(true) : null;
    if (fragment) {
      // Clear existing (fast & safe)
      container.replaceChildren(fragment);
    } else {
      kymeeSetInnerHTMLWithScripts(container, template.innerHTML);
    }

    if (typeof initCardSwiperTouch === 'function') initCardSwiperTouch();

    // Use requestAnimationFrame for async paint (avoids TBT)
    requestAnimationFrame(() => {
      popup.classList.add("active");
      document.body.classList.add("overflow-hidden");
    });
  };

  // 🧠 Helper: Close popup safely
  const closePopup = () => {
    requestAnimationFrame(() => {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    });
  };

  // 🎯 Event Delegation — only one listener (ultra efficient)
  document.addEventListener(
    "click",
    (e) => {
      const trigger = e.target.closest(".similar_products_trigger");
      if (trigger && trigger.dataset.productId) {
        openPopup(trigger.dataset.productId);
      }

      // Close logic (overlay or close button)
      if (
        e.target.classList.contains("similar-popup") ||
        e.target.closest(".popup-close")
      ) {
        closePopup();
      }
    },
    { passive: true } // 👈 Non-blocking for scrolling & gestures
  );
});
